import { LocalStorageKeys } from './storageUtils';

const RESORT_LOCATION_URL_PARAM_POSITION = 1;

/**
 * This function gets the resort location from the URL.
 * @param {boolean} withSlashes - Whether to include leading and trailing slashes. Defaults to true.
 * @returns {string} The resort location URL.
 */
export const getResortLocationUrl = (withSlashes = true) => {
  const urlParts = window.location.pathname.split('/');
  const resortLocation = urlParts[RESORT_LOCATION_URL_PARAM_POSITION];

  return withSlashes ? `/${resortLocation}/` : resortLocation;
};

/**
 * This function gets the resort short name from the URL.
 * Eg: /wisconsin-dells/ -> wisconsin-dells
 * @returns {string} The resort short name.
 */
export const getResortShortName = () => {
  return getResortLocationUrl(false);
};

export function getCurrentResortData() {
  const storedData = localStorage.getItem(LocalStorageKeys.CURRENT_RESORT_DATA);

  return storedData
    ? JSON.parse(storedData)
    : {
        resortDisplay: '',
        resortPhone: '',
        resortAddress: ''
      };
}

export function getCurrentResortDataFromLodges(locationList, resortShortName = getResortShortName()) {
  return Object.values(locationList).find(location => location.url === resortShortName);
}

export function updateCurrentResortData(locationList) {
  const locationData = getCurrentResortDataFromLodges(locationList);

  const dataToStore = {
    resortDisplay: locationData?.display ?? '',
    resortPhone: locationData?.phone ?? '',
    resortAddress: locationData?.address ?? ''
  };

  localStorage.setItem(LocalStorageKeys.CURRENT_RESORT_DATA, JSON.stringify(dataToStore));
  return dataToStore;
}
